"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Select_1 = require("../../../Shared/Components/Select");
const SortButton = ({ label, onChange, options, selected }) => {
    return ((0, jsx_runtime_1.jsx)("div", { "data-testid": "sort-button", children: (0, jsx_runtime_1.jsxs)("fieldset", { className: "gap-md flex flex-row items-center", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "sort-by", className: "body-md", children: [label, ":"] }), (0, jsx_runtime_1.jsx)("div", { className: "relative", children: (0, jsx_runtime_1.jsx)(Select_1.Select, { items: options, value: selected, onChange: onChange, id: "sort-by" }) })] }) }));
};
exports.SortButton = SortButton;
